import React from 'react';
import RiskTable from './RiskTable/RiskTable';
import HeatMap from './TreeMap/TreeMap';
import { withRouter } from 'react-router-dom';
import RiskFilterBody from '../Filter/RiskFilterBody';
import { useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
export const StyledSpinnerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
`;
export const StyledDataDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  background: rgba(235, 237, 239, 0.4);
`;

const ApplicationBody = ({
  heatMap,
  riskTableData,
  clickHandler,
  setRiskTablePage,
  setRiskTableRowsRowsPerPage,
  handleSetriskTableSortString,
  riskTableRowsPerPage,
  riskLoading,
  handleriskLoading,
  risknextTableData,
  riskColumOrder,
  riskColumOderBy,
  handleTableRowClick,
  isTreemapApplication
}) => {
  const showApply = useSelector(state => state.buttonSlice.showApply);
  const showGrid = useSelector(state => state.buttonSlice.showGrid);
  const showCard = useSelector(state => state.riskFilterSlice.showCard);
  const spinnerStatus = useSelector(state => state.spinner.loading);

  if (!showApply && !showCard) {
    if (showGrid && heatMap) {
      if (heatMap && !spinnerStatus) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, heatMap.series[0].data.length > 0 ? /*#__PURE__*/React.createElement(HeatMap, {
          heatMap: heatMap,
          clickHandler: clickHandler
        }) : /*#__PURE__*/React.createElement(StyledDataDiv, null, "No Data!!!"));
      } else {
        return /*#__PURE__*/React.createElement(StyledSpinnerDiv, null, /*#__PURE__*/React.createElement(CircularProgress, null));
      }
    } else {
      return /*#__PURE__*/React.createElement(RiskTable, {
        riskTableData: riskTableData,
        setRiskTablePage: setRiskTablePage,
        setRiskTableRowsRowsPerPage: setRiskTableRowsRowsPerPage,
        handleSetriskTableSortString: handleSetriskTableSortString,
        riskTableRowsPerPage: riskTableRowsPerPage,
        riskLoading: riskLoading,
        handleriskLoading: handleriskLoading,
        risknextTableData: risknextTableData,
        riskColumOrder: riskColumOrder,
        riskColumOderBy: riskColumOderBy,
        handleTableRowClick: handleTableRowClick,
        isTreemapApplication: isTreemapApplication
      });
    }
  } else {
    return /*#__PURE__*/React.createElement(RiskFilterBody, null);
  }
};

export default withRouter(ApplicationBody);